<template>
  <div class="kpt-admin-root kpt-single-page">
    <vue-headful title="Administration" />
    <header class="kpt-single-header">
      <h4>Administration</h4>
      <div class="page-control">
        <!-- <font-awesome-icon :icon="['far', 'thumbtack']" @click="pinToDash" title="Pin to Dashboard" class="has-cursor-pointer" /> -->
      </div>
    </header>
    <div class="kpt-admin-content">
      <nav class="tabs admin-nav">
        <ul>
          <li :class="{ 'is-active': isActive('adminAccount') }">
            <router-link :to="{ name: 'adminAccount' }">Account</router-link>
          </li>
          <li :class="{ 'is-active': isActive('adminUserManagement') }" v-if="$hasRole('Super User,Kymeta Admin,Sales Support,Product Support,Account Admin')">
            <router-link :to="{ name: 'adminUserManagement' }">Users</router-link>
          </li>
          <li :class="{ 'is-active': isActive('adminSoftware') }" v-if="$hasRole('Super User,Kymeta Admin')">
            <router-link :to="{ name: 'adminSoftware' }">Software</router-link>
          </li>
          <li :class="{ 'is-active': isActive('adminNetwork') }" v-if="$hasRole('Super User,Kymeta Admin')">
            <router-link :to="{ name: 'adminNetwork' }">Network</router-link>
          </li>
        </ul>
      </nav>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    isActive(routeName) {
      return routeName === this.$route.name;
    },
    pinToDash() {
      // TODO: Determine which tab we're on before pinning
    }
  },
  mounted() {
    this.$store.dispatch('fetchRoles');
    this.$store.dispatch('fetchUsers');
    this.$store.dispatch('fetchNms');
    this.$store.dispatch('fetchBeams');
  }
}
</script>
<style lang="scss" scoped>
nav.admin-nav {
  margin-bottom: 0;
}
.kpt-admin-root {
  height: 100%;
  display: flex;
  flex-direction: column;

  .kpt-admin-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }
}
</style>
